import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  IDepartmentsAddPayload,
  IDepartmentsUpdatePayload,
} from './departments.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  private getDepartamenteUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.getDepartments;
  private getDepartamenteDTUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.getDepartmentsDT;
  private storeDepartamenteUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.storeDepartment;
  private updateDepartamenteUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.putDepartment;
  private deleteDepartamenteUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.deleteDepartment;
  private getDepartamenteActiveUrl =
    this.basePath +
    environment.interop.platform.nomenclatoare.department.getDepartmentsActive;

  constructor(private http: HttpClient) {}

  getDepartamenteDT() {
    return this.http.get(this.getDepartamenteDTUrl, this.httpOptions);
  }

  addDepartamente(data: IDepartmentsAddPayload) {
    return this.http.post(this.storeDepartamenteUrl, data, this.httpOptions);
  }

  updateDepartamente(data: IDepartmentsUpdatePayload) {
    return this.http.put(this.updateDepartamenteUrl, data, this.httpOptions);
  }

  deleteDepartament(departamenteId: number) {
    return this.http.delete(this.deleteDepartamenteUrl + departamenteId);
  }

  getDepartamenteActive() {
    return this.http.get(this.getDepartamenteActiveUrl, this.httpOptions);
  }

  getDepartamente() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getDepartamenteUrl
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id_departament,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error('Error in get departments:', error);
          return throwError(error);
        })
      );
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
